import React from "react";
import '../styles/tss.scss';
import { MdOutlineRocketLaunch } from "react-icons/md";
import { GrServerCluster } from "react-icons/gr";

export default function TSS() {
    return (
        <section id="tss">
            <div className="container">
                <div className="d-flex flex-column gap-2 mb-lg-5 mb-md-4 mb-5">
                    <h1 className="h2 fw-bold text-center text-uppercase text-gradient m-0">Certifications</h1>
                </div>
                <div className="row m-0 gap-5 gap-md-0">
                    <div className="col-md-4 p-0 px-lg-3 px-md-2 ps-lg-0 ps-md-0 d-flex flex-column gap-3 column text-center" data-aos="fade-up">
                        <div className="m-0">
                            <span className="h1 lh-1 p-4 rounded-4 m-0 icon d-inline-flex justify-content-center align-items-center"><GrServerCluster /></span>
                        </div>
                        <h2 className="h3 heading-color m-0">Meta Frontend Developer Professional Certificate</h2>
                        <p className="m-0">An in-depth certification from Meta that has equipped me with advanced skills in frontend development, including mastering React, JavaScript, and modern web development practices. This certification highlights my ability to create responsive, high-performance web applications.</p>
                    </div>
                    <div className="col-md-4 p-0 px-lg-3 px-md-2 d-flex flex-column gap-3 column text-center" data-aos="fade-up">
                        <div className="m-0">
                            <span className="h1 lh-1 p-4 rounded-4 m-0 icon d-inline-flex justify-content-center align-items-center"><MdOutlineRocketLaunch /></span>
                        </div>
                        <h2 className="h3 heading-color m-0">Machine Learning Specialization</h2>
                        <p className="m-0">This specialization covers a broad range of machine learning techniques and applications. Through this certification, I've gained expertise in implementing machine learning algorithms, understanding deep learning, and applying these concepts to solve real-world problems..</p>
                    </div>
                    <div className="col-md-4 p-0 px-lg-3 px-md-2 pe-lg-0 pe-md-0 d-flex flex-column gap-3 column text-center" data-aos="fade-up">
                        <div className="m-0">
                            <span className="h1 lh-1 p-4 rounded-4 m-0 icon d-inline-flex justify-content-center align-items-center"><GrServerCluster /></span>
                        </div>
                        <h2 className="h3 heading-color m-0">Python Programmer Bootcamp</h2>
                        <p className="m-0">A comprehensive bootcamp that provided a solid foundation in Python programming. This certification emphasizes my proficiency in Python, covering essential topics such as data structures, object-oriented programming, and web development with frameworks like Django and Flask.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}